interface _Edge {
  node?: object | null;
}

export interface NonNullEdge<Node> {
  node: Node;
}

// Extracts the edges from a GQL connection into an array, filtering out null edges/nodes.
export function getEdgesFromConnection<Node, Edge extends _Edge>(
  connection?: {
    edges: (Edge | null)[] | null;
  } | null,
): (Edge & NonNullEdge<Node>)[] {
  return (connection?.edges?.filter(e => e?.node) ?? []) as (Edge & NonNullEdge<Node>)[];
}
